<template>
  <div class="text-center div_btn_inline">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-btn
            color="default"
            icon
            @click="goInicioDisenarEncuesta"
          >
            <v-icon>
              mdi-cogs
            </v-icon>
          </v-btn>
        </div>
      </template>
        <span>Diseñar Encuesta (Secciones, Preguntas y Respuestas)</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ButtonInicioDisenarEncuesta",
  components: {
  },
  props: {
    idServicio: {
      type: Number,
      required: true
    },
    idEncuesta: {
      type: Number,
      required: true
    },
    tokenEncuesta: {
      type: String,
      required: true
    },
  },
  data() {
    return {
    };

  },
  computed: {
  },
  watch:{
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    goInicioDisenarEncuesta() {
      this.$router.push({
        path: `/Encuesta/Diseno/${this.idServicio}/${this.idEncuesta}/${this.tokenEncuesta}`,         
      });
    },
  },  
};
</script>